import { mode, StyleFunctionProps } from '@chakra-ui/theme-tools';
import type { ComponentStyleConfig } from '@chakra-ui/theme';

const Empty: ComponentStyleConfig = {
  parts: ['Container', 'Icon', 'Description'],
  baseStyle: (props: StyleFunctionProps) => {
    return {
      Container: {
        gap: 2,
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        py: 4,
      },
      Icon: {
        h: '20',
      },
      Description: {
        color: mode('black', 'gray.500')(props),
      },
    };
  },
};

export default Empty;
